/* -------------------------------------------------------------------------- */
/*                             Jobs Navigation                                */
/* -------------------------------------------------------------------------- */

import jobs from 'views/screens/Jobs/sidebarLayout';

export default [
  {
    header: 'jobs.jobs',
    iconName: 'Jobs',
    children: [...jobs] //Only to check permission in children inside
  },
  ...jobs
];
